var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("扫码填写考试资料")]),_c('qrcode',{attrs:{"value":_vm.qrcode,"options":{ width: 210 }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }